import { useState } from "react";
import { Stagger, StaggerItem } from "../common/Reveal";
import { SectionHeading } from "../common/SectionHeading";
import { CTAButton } from "../common/CTAButton";
import { industries } from "../../data/content";
import { X } from "@phosphor-icons/react";

export const IndustriesGrid = ({ dark = false, limit, showCta = true }) => {
    const [active, setActive] = useState(null);
    const list = limit ? industries.slice(0, limit) : industries;

    return (
        <section className={`relative ${dark ? "bg-navy grain" : "bg-[#f8fafc]"}`} data-testid="industries-grid">
            <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-24 lg:py-32">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
                    <SectionHeading
                        dark={dark}
                        overline="Industries We Serve"
                        title="Workforce solutions across every sector"
                        subtitle="From agriculture to AI, FRONTX deploys the right workforce for more than 20 industries across India."
                    />
                    {showCta && limit && (
                        <CTAButton to="/industries" variant={dark ? "outline" : "outlineNavy"} className="shrink-0">View All Industries</CTAButton>
                    )}
                </div>

                <Stagger className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {list.map((ind) => (
                        <StaggerItem key={ind.name}>
                            <button
                                onClick={() => setActive(ind)}
                                data-testid={`industry-${ind.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                className={`group text-left w-full h-full p-6 rounded-sm border transition-all duration-300 hover:-translate-y-1 ${
                                    dark ? "bg-slate-800 border-white/10 hover:border-brand" : "bg-white border-slate-200 hover:border-brand"
                                }`}
                            >
                                <ind.icon size={34} weight="duotone" className="text-brand transition-transform duration-300 group-hover:scale-110" />
                                <h3 className={`mt-5 font-display font-bold text-base leading-tight ${dark ? "text-white" : "text-navy"}`}>{ind.name}</h3>
                                <span className="mt-3 inline-block text-[11px] uppercase tracking-wider font-semibold text-brand">View roles →</span>
                            </button>
                        </StaggerItem>
                    ))}
                </Stagger>
            </div>

            {active && (
                <div className="fixed inset-0 z-[60] grid place-items-center p-5 bg-navy-deep/80 backdrop-blur-sm" onClick={() => setActive(null)} data-testid="industry-modal">
                    <div className="bg-white rounded-sm max-w-lg w-full p-8 relative" onClick={(e) => e.stopPropagation()}>
                        <button onClick={() => setActive(null)} className="absolute top-5 right-5 text-slate-400 hover:text-navy" data-testid="industry-modal-close"><X size={24} /></button>
                        <active.icon size={44} weight="duotone" className="text-brand" />
                        <h3 className="mt-4 font-display font-extrabold text-2xl text-navy">{active.name}</h3>
                        <div className="mt-2 text-xs uppercase tracking-wider font-semibold text-slate-500">Typical Roles Deployed</div>
                        <p className="mt-4 text-sm text-slate-600 leading-relaxed">{active.roles}</p>
                        <div className="mt-6">
                            <CTAButton to="/contact#manpower" variant="primary">Request Manpower</CTAButton>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};
